
<template>
  <div
    class="row"
    @click="rowClick"
  >
    <!--
        Using a div here to take advantage of background position/size.
        We could/should use an img and the object-fit and object-position properties to do the same but it is not supported in IE11.
      -->
    <div
      v-if="thumbnail"
      class="thumbnail thumbnail-img"
      role="img"
      :aria-label="`Media for ${name}`"
      :style="{ backgroundImage: thumbnail }"
    />
    <div
      v-else
      class="thumbnail"
    />
    <div class="name">
      {{ name }}
    </div>
    <div class="action-container">
      <span
        v-if="state"
        class="state-text"
      ><icon
        v-if="completed"
        name="check"
        variant="white"
        class="completed-icon"
      /> {{ stateText }}</span>
      <icon
        name="arrow"
        class="arrow"
        variant="4fb9de"
      />
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'LearningModuleListRow',
  components: { Icon },
  props: {
    card: {
      type: Object,
    },
  },
  emits: ['row-clicked'],
  computed: {
    name() {
      if (this.card) {
        return this.card.title;
      }
    },
    completed() {
      return this.state && this.state.status === 'completed';
    },
    state() {
      return this.$store.getters['learningModuleStates/get'][this.card?.assetId];
    },
    stateText() {
      // This will only be access if state exists so we can make an assumption that we will always be either started or completed
      return this.completed ? 'Complete' : 'Continue';
    },
    thumbnail() {
      if (this.card) {
        const url = this.$store.getters['attachments/get'][this.card.featuredImageId]?.smallThumbnail;
        if (url) {
          return `url("${url}")`;
        }
      }
    },
  },
  methods: {
    rowClick() {
      this.$emit('row-clicked', this.card);
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  color: #000000;
  font-size: rem-calc(14);

  .name {
    align-items: center;
    color: #000000;
    display: flex;
    flex: 1;
    margin-left: rem-calc(24);
  }

  .thumbnail {
    align-items: center;
    background-color: #ebedef;
    display: flex;
    flex-shrink: 0;
    height: 39px;
    justify-content: center;
    width: 70px;

    &.thumbnail-img {
      background-position: center;
      background-size: cover;
    }
  }

  .action-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    min-width: rem-calc(60);

    @include breakpoint(small) {
      flex-direction: column-reverse;
      min-width: rem-calc(40);
    }

    .state-text {
      margin-right: rem-calc(20);

      .completed-icon {
        width: rem-calc(10);
        height: rem-calc(10);
        padding: 2px;
        border-radius: 100%;
        background-color: #00b46d;
        vertical-align: middle;
        margin-right: rem-calc(4);
      }
    }

    .arrow {
      margin-left: auto;

      @include breakpoint(small) {
        margin-left: 0;
      }
    }
  }
}
</style>
